// extracted by mini-css-extract-plugin
module.exports = {"button":"BtnRecherche_button__3ZfVN","active":"BtnRecherche_active__5Rj6S","svg":"BtnRecherche_svg__1c_Zx"};